import styles from "./style.module.css";
import { Link, useNavigate } from "react-router-dom";
import MainButton from "../../../components/Admin/MainButton/MainButton";
import { useContext, useEffect, useState } from "react";
import Input from "../../../components/Common/Input/Input";
import PasswordInput from "../../../components/Common/PasswordInput/PasswordInput";
import { validate } from "../../../functions/validate";
import { userContext } from "../../../contextAdmin/Admin/User";
import { users } from "./data";
import authRequets from "../../../components/api/authRequests";
import { updateAuthorizationHeader } from "../../../components/api/mainAxios";
// Creator : Team e - chanan
function Login() {
  const { user, setUser } = useContext(userContext);
  const [valid, setValid] = useState([]);
  const [error, setError] = useState("")
  const navigate = useNavigate();

  const getDatafromForm = (formData) => ({
    email: formData.get("email"),
    password: formData.get("password"),
  })

  const handleSubmit = async (e) => {
    e.preventDefault();

    const body = getDatafromForm(new FormData(e.currentTarget))

    const checkResult = validate(body)

    setValid(checkResult)

    if (checkResult.length) return;

    try {
      const data = await authRequets.login(body);
      console.log("🚀 ~ handleSubmit ~ data:", data.user)
      if (data.user.permissions == "viewer") {
        throw { message: "Sorry, you are not authorized" }
      }
      setUser(data?.user)
      // updateAuthorizationHeader(data?.token);
      localStorage.setItem("access_token", data?.token);
      localStorage.setItem("refresh_token", data?.refreshToken);
      if (data.user.permissions == "admin") {
        navigate("/teachers", { replace: true, state: body });

      } else if (data.user.permissions == "teacher") {

        navigate("/classrooms", { replace: true, state: body });

      }
      // setUser(users[0])
      console.log(body);
    } catch (err) {
      if (err.message) {
        let msg = err.message;
        console.log("🚀 ~ handleSubmit ~ msg:", msg.split("/")[1])
        if (msg.includes("auth")) {
          msg = "Sorry, " + (msg.split("/")[1] ? msg.split("/")[1].replace(`).`, "").replaceAll("-", " ") : msg.split(",")[1])
        }
        setError(msg)
      }
      console.log(err);
    }
  };


  useEffect(() => {
    if (error) {

      setTimeout(() => {
        authRequets.signOutUser().then(() => { setError(""); setUser("") })
      }, 2000)
    }
  }, [error])
  return (
    <div className={`${styles["login-container"]} pages`}>

      <div className={styles["all-login"]}>
        <div className={styles["image"]}>
          <img className={styles["image 1"]} src={require("./image 1.png")} alt="some" />
          <img className={styles["image 2"]} src={require("./image 2.png")} alt="some" />
        </div>
        <h1>Welcome back!</h1>
      </div>

      <form className={`two-colored-div ${styles.loginBox}`} onSubmit={handleSubmit}>
        <Input
          name={"email"}
          type={"email"}
          legend={"Email"}
          valid={!valid.includes("email")}
        />
        <PasswordInput
          name={"password"}
          type={"password"}
          legend={"Password"}
          valid={!valid.includes("password")}
        />
        <Link className={styles["forgot-password"]} to="/password">
          Forgot Password?
        </Link>
        <MainButton>SIGN IN</MainButton>
        {error && <div className={styles.errorBox}>{error}</div>}
      </form>
    </div>
  );
}

export default Login;
